import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import pure from '../lib/pure';
import styles from './style.css';
import Sizes from './Sizes';
import LoadingIndicator from '../components/LoadingIndicator/LoadingIndicator';

function LoadingScreen({ position, isLoading, size }) {
  return (
    <span
      className={classNames([
        styles.hiddenLoadingScreen,
        { [styles.loadingScreen]: isLoading },
        {
          [styles.fixed]: position === 'fixed',
          [styles.absolute]: position === 'absolute',
        },
      ])}
    >
      {size === Sizes.LARGE && isLoading && (
        <div className={styles.ldsEllipsis}><div /><div /><div /><div /></div>
      )}

      {size === Sizes.SMALL && (
        <div>
          <LoadingIndicator isLoading={isLoading} />
        </div>
      )}
    </span>
  );
}

LoadingScreen.defaultProps = {
  position: 'absolute',
  isLoading: false,
  size: Sizes.LARGE,
};

LoadingScreen.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(['fixed', 'absolute']),
  size: PropTypes.oneOf(Object.values(Sizes)),
};

export { Sizes };
export default pure(LoadingScreen);
